<div class="amp-dialog">
    <span class="amp-dialog-title">Autenticação de Dois Fatores</span>
    <span class="amp-dialog-subtitle">O proprietário da conta solicita que todos os usuários utilizem a Autenticação de
        Dois Fatores. Clique no botão abaixo para configurar.</span>
    <button (click)="redirect()" class="amp-btn-success">Configurar</button>
</div>